
//
// Implicit link
//
// Make all cells in a table row act like a link unless marked otherwise.
//

module.exports = function ImplicitLink ($host, config) {

  // Listeners
  $host.on('click', '[data-implicit-link] td', function () {
    var $row = $(this), link = $row.parents('[data-implicit-link]').data('implicit-link');
    log('implicit link:', link);

    if (link && !isdef(this.dataset.disableImplicitLinking)) {
      window.location = link;
    } return event;
  });

}

